import { Component, OnInit, Input } from '@angular/core';
import { Alert, StatusEnum } from '../Alert';
import { GlobalsService } from '../globals.service';

export function StatusEnumAware(constructor: Function) {
  constructor.prototype.StatusEnum = StatusEnum;
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
@StatusEnumAware
export class AlertComponent implements OnInit {

  @Input()
  live: boolean;

  @Input()
  mobile = false;

  // List of alerts
  alerts: Alert[] = [
    new Alert(
      'Alert 1',
      4,
      'Staff',
      'Understaffed in shipping',
      'Only 60% of staff present in shipping department.',
      ['Calling people in.', 'Still short-staffed.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.viewable
    ),
    new Alert(
      'Alert 2',
      8,
      'Timing',
      'Late plane',
      'Plane departure delayed by 30 minutes. Expected arrival at 8:30.',
      ['Some note about plane departure.', 'Another note.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.viewable
    ),
    new Alert(
      'Alert 3',
      8,
      'Environmental',
      'Icy roads',
      'Ice-covered roads on I-55. Shipment from some city postponed.',
      ['Some note about road status.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.viewable
    ),
    new Alert(
      'Alert 4',
      4,
      'Volume',
      'Additional inbound truck',
      'Additional inbound truck with 700 packages expected to arrive at 12:15.',
      ['First note about inbound truck.', 'Second note about inbound truck.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.resolved
    ),
    new Alert(
      'Alert 5',
      3,
      'Volume',
      'Additional inbound plane',
      'Additional inbound truck with X packages expected to arrive at 1:00.',
      ['First note about inbound plane.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.resolved
    ),
    new Alert(
      'Alert 6',
      2,
      'Staff',
      'Understaffed in shipping',
      'Only 85% of staff present in shipping department.',
      ['Calling people in.', 'Done'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.resolved
    ),
    new Alert(
      'Alert 7',
      9,
      'Environmental',
      'Thunderstorm',
      'Severe thunderstorm warning.',
      ['Power out for 15 minutes.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.resolved
    ),
    new Alert(
      'Alert 8',
      9,
      'Timing',
      'Plane departure delayed',
      'Planed delayed until tomorrow.',
      ['Note about delayed plane.'],
      new Date('2016-01-17T08:44:29+0100'),
      new Date('2016-01-17T08:44:29+0100'),
      StatusEnum.resolved
    ),
  ];

  get alertsShow() {
    return this.globals.newestFirst === 0 ? this.alerts : this.alerts.reverse();
  }

  constructor(
    public globals: GlobalsService,
  ) { }

  ngOnInit() {
    // Here we should load settings / filters from toolsService
    // this.toolsService. (blah blah blah)
  }

  filterShow(alert: Alert) {
    return (
      (alert.priority > 5 && this.globals.highPriority) ||
      (alert.priority <= 5 && this.globals.lowPriority)
    ) && (
      (alert.alertType === 'Staff' && this.globals.staffType) ||
      (alert.alertType === 'Environmental' && this.globals.environmentalType) ||
      (alert.alertType === 'Timing' && this.globals.timingType) ||
      (alert.alertType === 'Volume' && this.globals.volumeType)
    ) && (
      (alert.status === StatusEnum.viewable && this.live) ||
      !this.live
    );
  }

  get hasOneOrMoreAlerts() {
    for (const a of this.alerts) {
      if (this.filterShow(a)) {
        return true;
      }
    }
    return false;
  }

  resetTools() {
    this.globals.resetFilters();
  }

}



// WEBPACK FOOTER //
// /Users/charles/Documents/AState-Senior/HCI/proj/amd2/src/app/alert/alert.component.ts